import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { NavigationButtonComponent } from './components/navigation-button/navigation-button.component';
import { PatientNavbarComponent } from './patient-navbar.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [PatientNavbarComponent, NavigationButtonComponent],
  exports: [PatientNavbarComponent, NavigationButtonComponent],
  imports: [CommonModule, NgxBootstrapIconsModule, BsDropdownModule],
})
export class PatientNavbarModule {}
